import { pxToRem } from '../../../../utils';
var carouselStyles = {
  root: function root() {
    return {
      display: 'inline-block'
    };
  },
  itemsContainerWrapper: function itemsContainerWrapper(_ref) {
    var v = _ref.variables,
        p = _ref.props;
    return Object.assign({
      display: 'flex',
      width: pxToRem(v.width),
      overflowX: 'hidden',
      border: '1px solid transparent'
    }, p.shouldFocusContainer && p.isFromKeyboard && {
      border: "1px solid " + v.focusOuterBorderColor,
      borderRadius: v.focusOuterBorderRadius
    });
  },
  itemsContainer: function itemsContainer() {
    return {
      padding: 0,
      margin: 0,
      display: 'flex',
      listStyle: 'none',
      willChange: 'transform'
    };
  }
};
export default carouselStyles;
//# sourceMappingURL=carouselStyles.js.map
